import React from "react";
import FeatureStyleOne from "../pages/FeatureStyleOne";
import TestimonialsAbout from "../pages/Testimonialsabout";
import VisionMission from "./VisionMission";

const AboutStyleTwo = () => {
  return (
    <>
      <div className="breadcrumb-bar">
        <div className="container">
          <div className="row align-items-center text-center">
            <div className="col-md-12 col-12">
              <h2 className="breadcrumb-title text-white">
                About Us
              </h2>
            </div>
          </div>
        </div>
      </div>

      <section className="about-style-two p-0">
        <div className="container">
          <div className="row">

            {/* Left Content */}
            <div className="col-lg-6">
              <div className="content-block">
                <div className="block-title">
                  <div className="dot-line"></div>
                  <p>Your trusted partner for safe Travel</p>
                 <h2>
  Travel Comfortably With <br /> Om Sai Cab Service
</h2>
                </div>

             <p>
  Om Sai Cab Service provides safe, reliable, and affordable taxi services for local and outstation travel. We focus on comfort, punctuality, and customer satisfaction. Whether it's airport transfers, city rides, railway station pickups, or long-distance trips, we are always ready to serve you with professional drivers and well-maintained vehicles.
</p>

<p>
  Our goal is to make every journey smooth and stress-free with 24/7 booking support and quick response service. We ensure transparent pricing with no hidden charges, so you can travel with complete peace of mind anytime, anywhere.
</p>

<p>
  With years of experience in the transportation industry, Om Sai Cab Service has earned the trust of countless customers through dependable service and a customer-first approach. We understand that every traveler has unique needs, which is why we offer flexible travel solutions for individuals, families, tourists, and corporate clients.
</p>

<p>
  Our fleet includes clean, comfortable, and regularly maintained vehicles to ensure a safe and enjoyable travel experience. From short city commutes to multi-day outstation tours, our skilled and courteous drivers are committed to providing a hassle-free journey while maintaining the highest standards of safety and professionalism.
</p>


                {/* <a href="/contact" className="about-btn">
                  Discover More
                </a> */}
              </div>
            </div>

            {/* Right Image Section */}
            <div className="col-lg-6">
              <div className="hvr-float-shadow">
                <div className="image-block ">
                  <img
                    src="images/resources/about-1-1.jpg" className="img-fluid "
                    alt="Om Sai Cab Service"
                  />

                  <div className="bubble-block">
                    <div className="inner-block">
                      <p>Trusted rides completed</p>
                      <span className="counter">1000+</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>
<VisionMission/>
      <FeatureStyleOne />
      <TestimonialsAbout/>
    </>
  );
};

export default AboutStyleTwo;